export default {
  signalsNotFound: 'Nie znaleziono następujących sygnałów: {signalNames}',
};
